/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kullanim_S5_P1Inputs */

const tr_kullanim_s5_p1 = /** @type {(inputs: Kullanim_S5_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu Sözleşme Türk Hukuku'na tabidir.`)
};

const en_kullanim_s5_p1 = /** @type {(inputs: Kullanim_S5_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This Agreement is governed by Turkish law.`)
};

const de_kullanim_s5_p1 = /** @type {(inputs: Kullanim_S5_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieser Vertrag unterliegt türkischem Recht.`)
};

const ru_kullanim_s5_p1 = /** @type {(inputs: Kullanim_S5_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Настоящий Договор регулируется правом Турции.`)
};

/**
* | output |
* | --- |
* | "This Agreement is governed by Turkish law." |
*
* @param {Kullanim_S5_P1Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const kullanim_s5_p1 = /** @type {((inputs?: Kullanim_S5_P1Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kullanim_S5_P1Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kullanim_s5_p1(inputs)
	if (locale === "de") return de_kullanim_s5_p1(inputs)
	if (locale === "ru") return ru_kullanim_s5_p1(inputs)
	return tr_kullanim_s5_p1(inputs)
});